import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import type { DashboardDriverWorkloadEntryDto } from "@carry/contract";
import { sortDriverBars } from "./chart-data";
import { chartColors } from "./chart-colors";

/**
 * ドライバー別配送件数 (横棒). total 降順. 完了/未完 (= total - completed) のスタック.
 * 0 件のときは空メッセージを表示する.
 */
export function DriverBarChart({ byDriver }: { byDriver: DashboardDriverWorkloadEntryDto[] }) {
  const data = sortDriverBars(byDriver).map((d) => ({
    name: d.driver_name,
    completed: d.completed,
    remaining: Math.max(0, d.total - d.completed),
  }));
  const height = Math.max(160, data.length * 40 + 48);
  return (
    <div className="panel" style={{ padding: "18px 20px" }}>
      <div className="eyebrow" style={{ marginBottom: 4 }}>
        ドライバー別 配送件数
      </div>
      <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 16 }}>本日</div>
      {data.length === 0 ? (
        <div
          style={{ fontSize: 12, color: "var(--ink-3)", padding: "40px 0", textAlign: "center" }}
        >
          本日割り当てられたドライバーはいません
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={height}>
          <BarChart
            layout="vertical"
            data={data}
            margin={{ top: 4, right: 16, bottom: 4, left: 8 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke={chartColors.grid()} horizontal={false} />
            <XAxis
              type="number"
              allowDecimals={false}
              tick={{ fontSize: 10, fill: chartColors.axis() }}
              stroke={chartColors.grid()}
            />
            <YAxis
              type="category"
              dataKey="name"
              width={88}
              tick={{ fontSize: 11, fill: chartColors.axis() }}
              stroke={chartColors.grid()}
            />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar dataKey="completed" name="完了" stackId="a" fill={chartColors.completed()} />
            <Bar dataKey="remaining" name="予定" stackId="a" fill={chartColors.planned()} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
